module.exports = __webpack_public_path__ + "img/test_r5.3b033d23.png";